import { Seconds } from 'app/shared/types/Seconds.type';
import { Milliseconds } from 'app/shared/types/Milliseconds.type';

export function getInMilliseconds(seconds: Seconds): Milliseconds {
  const SECOND = 1000;
  return seconds * SECOND;
}
